<template>
  <div id="nav">
    <router-view />
  </div>
</template>

<style lang="scss">
</style>
